(function($) {

    'use strict';

    var galleries = [];

    var init = function() {
        $('.js-images-gallery a').on('click', displayGallery);
    };

    var initGallery = function(el) {
        // Init empty gallery array
        var container = [];

        // Loop over gallery items and push it to the array
        el.find('figure').each(function(){
            var $link = $(this).find('a');

            if($link.data('type') === 'video') {
                // video
                var item = {
                    html: $link.data('video')
                }
            } else {
                // image
                var item = {
                    src: $link.attr('href'),
                    w: $link.data('width'),
                    h: $link.data('height'),
                    title: $link.data('caption')
                };
            }

            container.push(item);
        });

        // galleries.push(container);
        return container;
    }

    var displayGallery = function(event) {
        // Prevent location change
        event.preventDefault();
        var item = event.currentTarget,
            galleryParent = $(item).closest('.js-images-gallery');

        var container = initGallery($(galleryParent));

        // Define object and gallery options
        var $pswp = $('.pswp')[0],
            options = {
                index: $(this).closest('.js-images-gallery-item').index(),
                bgOpacity: 0.85,
                showHideOpacity: true,
                fullscreenEl: false,
                shareEl: false,
            };

        // Initialize PhotoSwipe
        var gallery = new PhotoSwipe($pswp, PhotoSwipeUI_Default, container, options);
        gallery.init();
    }

    $(document).ready(function() {
        init();
    });

})(jQuery);
